 function getValueCardBg(img) {
	let cardbg = img
	let arr = [
		'https://static.52drama.com/ihuopiao/stored/c1.png',
		'https://static.52drama.com/ihuopiao/stored/c2.png',
		'https://static.52drama.com/ihuopiao/stored/c3.png',
		'https://static.52drama.com/ihuopiao/stored/c4.png',
		'https://static.52drama.com/ihuopiao/stored/c5.png',
		'https://static.52drama.com/ihuopiao/stored/c6.png',
		'https://static.52drama.com/ihuopiao/stored/c7.png',
		'https://static.52drama.com/ihuopiao/stored/c8.png',
		'https://static.52drama.com/ihuopiao/stored/c9.png',
		'https://static.52drama.com/ihuopiao/stored/c10.png'
	]
	let arr2 = [
		'https://static.52drama.com/ihuopiao/stored/xc1.png',
		'https://static.52drama.com/ihuopiao/stored/xc2.png',
		'https://static.52drama.com/ihuopiao/stored/xc3.png',
		'https://static.52drama.com/ihuopiao/stored/xc4.png',
		'https://static.52drama.com/ihuopiao/stored/xc5.png',
		'https://static.52drama.com/ihuopiao/stored/xc6.png',
		'https://static.52drama.com/ihuopiao/stored/xc7.png',
		'https://static.52drama.com/ihuopiao/stored/xc8.png',
		'https://static.52drama.com/ihuopiao/stored/xc9.png',
		'https://static.52drama.com/ihuopiao/stored/xc10.png'
	]
	arr.forEach((current, index) => {
		if(current == img) {
			cardbg = arr2[index]
		}
		
	})
	return cardbg
}
module.exports = {
	getValueCardBg
}